import React from 'react';
import { Form, Radio } from 'antd';
import { FormItem } from '@xbcb/form-item-components';
import { shouldUpdate, getCodes } from '@xbcb/ui-utils';
import { clearFields } from 'libs/clearFields';
import { useTheme } from 'styled-components';
import { NamePath } from '@xbcb/ui-types';
import DisclaimerSelect from 'components/DisclaimerSelect';
import { StyledCpscCoreFormDiv } from './styles';

const PROCESSING_TYPES = {
  DISCLAIM: 'DISCLAIM',
  REF: 'REF',
  FULL: 'FULL',
} as const;

export interface CpscCoreFormProps {
  fullNamePath: NamePath;
  localNamePath: NamePath;
  readOnly?: boolean;
  required?: boolean;
  disabled?: boolean;
}

const CpscCoreForm: React.FC<CpscCoreFormProps> = ({
  fullNamePath,
  localNamePath,
  readOnly,
  required,
  disabled,
}) => {
  const codes = getCodes();
  const { flag: pgaFlags, disclaimer: disclaimerCodes } = codes.CBP.CATAIR.PGA;
  const form = Form.useFormInstance();
  const theme = useTheme();
  const cpscFlag = pgaFlags.CP1;
  const filterDisclaimerCodes = cpscFlag?.disclaimerCodes;
  const cpscDescription = cpscFlag?.text;

  return (
    <StyledCpscCoreFormDiv>
      <p>{cpscDescription}</p>
      <FormItem
        name={[...localNamePath, 'processingType']}
        rules={[{ required, message: ' ' }]}
        $readOnly={readOnly}
        $itemSize={theme.size.short}
      >
        <div className="radio-group-horizontal">
          <Radio.Group
            disabled={disabled || readOnly}
            onChange={clearFields({
              form,
              fullNamePath,
              fields: ['disclaimerCode'],
            })}
          >
            <Radio value={PROCESSING_TYPES.DISCLAIM}>Disclaim</Radio>
            <Radio value={PROCESSING_TYPES.REF}>
              Reference PGA message set
            </Radio>
            <Radio value={PROCESSING_TYPES.FULL}>Full PGA message set</Radio>
          </Radio.Group>
        </div>
      </FormItem>

      <Form.Item
        shouldUpdate={shouldUpdate([[...fullNamePath, 'processingType']])}
        noStyle
      >
        {() => {
          const processingType = form.getFieldValue([
            ...fullNamePath,
            'processingType',
          ]);
          return (
            processingType === PROCESSING_TYPES.DISCLAIM && (
              <DisclaimerSelect
                localNamePath={[...localNamePath, 'disclaimerCode']}
                label="Disclaim reason"
                disclaimerCodes={disclaimerCodes}
                filter={filterDisclaimerCodes}
                required={required}
                readOnly={readOnly}
                disabled={disabled}
              />
            )
          );
        }}
      </Form.Item>
    </StyledCpscCoreFormDiv>
  );
};

export default CpscCoreForm;
